import models from './models'
import menu from './menu'
import routes from './routes'

export default {

  name: 'CMS',

  setup () {
    return {
      menu,
      routes
    }
  },

  models () {
    return {
      'template': models.Template,
      'page': models.Page,
      'component': models.Component,
      'template_settings': models.Settings
    }
  }

}
